import React from 'react';
import styled from 'styled-components';
import { CommonStyles } from '../BasicDetails/BasicDetails';
import successIcon from '../../../images/success-icon.png';
import { SharedStyledComponents } from '../OnboardingPage';

const KYCSuccess = () => {
  const { SuccessWrapper } = SharedStyledComponents;
  return (
    <SuccessWrapper>
      <div className="detail-saved">
        <div className="head">
          <div className="success-icon">
            <img src={successIcon} alt="success" />
          </div>
          <h3>KYC details submitted successfully</h3>
          <p>Your KYC details have been submitted for verification</p>
        </div>
      </div>
    </SuccessWrapper>
  );
};

export default KYCSuccess;
